import { useState } from 'react';
import { v4 as uuid } from 'uuid';

export const useUuid = (): [string, () => void] => {
  const [id, setId] = useState(uuid());
  const updateId = () => setId(uuid());
  return [id, updateId];
};
